import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseIcon, SageIcon } from '@/components/common/icon';

export default function PaymentSecured() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return (
    <div className="self-stretch px-4 py-3 bg-[#ECFDF5] rounded-lg inline-flex justify-start items-start gap-3 mb-6">
      <div className="flex-1 inline-flex flex-col justify-start items-start gap-1">
        <div className="inline-flex justify-start items-center gap-2">
          <SageIcon />
          <div className="justify-start text-font&icon-primary text-base font-semibold font-['DM_Sans'] leading-normal">
            {t('payment.secured.title', {
              defaultValue: 'Your payment is secured'
            })}
          </div>
        </div>
        <div className="self-stretch pl-7 inline-flex justify-start items-center gap-2.5">
          <div className="flex-1 justify-start text-font&icon-secondary text-sm font-normal font-['DM_Sans'] leading-snug">
            {t('payment.secured.description', {
              defaultValue:
                'The brand has funded all deals. Your payout is safely held by Airwallex, which complies with industry standards (PCI DSS & GDPR) to protect your data. Funds can be withdrawn to your designated payment method (PayPal or bank transfer) 10 days after you submit the final link. Head does not handle or access any of your payment information.'
            })}
          </div>
        </div>
      </div>
      <div
        className="w-5 h-5 relative cursor-pointer"
        onClick={() => setVisible(false)}
      >
        <CloseIcon className="w-[14px] h-[14px]" />
      </div>
    </div>
  );
}
